@if (
  {
    results: (searchParams.results | async) || [],
    isvalid: searchParams.isValid | async,
    messages: searchParams.messages | async,
    cheapest: searchParams.cheapest | async,
    originalUserSearch: this.searchParams.originalUserSearch,
    fullWidth:
      this.searchParams.originalUserSearch.chosenSearchType === RailJourneyType.SingleJourney ||
      this.searchParams.originalUserSearch.chosenSearchType === RailJourneyType.OpenReturnJourney
  };
  as data
) {
  <span class="visuallyhidden" role="alert">Rail search complete</span>
  <div>
    <h2 class="visuallyhidden" i18n="@@searchCriteria">Search Criteria</h2>
    <a
      href="#trains-link"
      (click)="skipToResultContent()"
      role="link"
      class="sr-only sr-only-focusable"
      >Skip to result content</a
    >
    <app-invoked-user></app-invoked-user>
  </div>
  @if (!(searchParams.isLoading | async)) {
    <div>
      <!-- search form -->
      <app-validate-errors [messages]="data.messages"></app-validate-errors>
      <div class="rail_search_content background-container-background" id="rail_research_container">
        <app-search-toggle #searchToggle [serviceType]="ServiceType.Rail">
          <a
            href="javascript:void(0)"
            (click)="skipToResultContent()"
            class="sr-only sr-only-focusable"
            >Skip to result content</a
          >
          <app-rail-search></app-rail-search>
          <div class="flex-row-container flex-row-container--right">
            @if (showDebug) {
              <button appButton="large-search" (click)="alwaysLog(data.results[0])">Dump</button>
            }
            <button
              i18n-title
              appButton="large-search"
              title="Start another search"
              (click)="reSearch()"
              i18n="@@railSearch"
            >
              Search
            </button>
          </div>
        </app-search-toggle>
      </div>
      <app-risk-alerts [countryCode]="'GB'"></app-risk-alerts>
      @if (data.results[0] && data.originalUserSearch) {
        <div id="trains-link" class="rail_search_results">
          @if (flightSearchParams.railFromFlightSearchPerformed) {
            <app-carbon-comparison> </app-carbon-comparison>
          }
          <div class="flex-row-container switchrail_container">
            @if (
              searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount &&
              !searchParams.isRailHotelComboSearch
            ) {
              <button
                (click)="switchToHotel()"
                appButton="small"
                class="alternative-button"
                id="railresults-button-switchtoHotel"
              >
                <i class="ico-bed" aria-hidden="true"></i>
                <span i18n="@@railHotelsFrom">Hotels From:</span>&nbsp;
                {{
                  searchService.searches[ServiceType.Hotel].cheapestPrice.amount
                    | currency: searchService.searches[ServiceType.Hotel].cheapestPrice.currencyCode
                }}
              </button>
            }
          </div>
          @if (searchParams.isRailHotelComboSearch) {
            <div class="flex-row-container switchrail_container alternative-button">
              <app-hotel-switch-button (switchToHotel)="switchToHotel()"> </app-hotel-switch-button>
            </div>
          }
          @if (data.results[0]?.outbound.length || data.results[0]?.return.length) {
            <div class="search_results_header">
              @if (flightSearchParams.railFromFlightSearchPerformed) {
                <button
                  appButton="small"
                  class="back-to-button"
                  (click)="switchToFlight()"
                  i18n="@@backToFlights"
                  id="rail-button-back-to-flights"
                >
                  <i class="ico-flight" aria-hidden="true"></i>
                  Back to flights
                </button>
              }
              <div class="cheapest_fares_container">
                <h2 i18n="@@railTrainsCheapestFares">Cheapest fares:</h2>
                <ul class="cheapest_fares_list">
                  @if (
                    data.originalUserSearch.chosenSearchType === RailJourneyType.ReturnJourney &&
                    data.cheapest.outboundCheapest.returnJourneyFares.price &&
                    data.cheapest.cheapestClassTicketReturn.standardClassFare.price
                  ) {
                    <li>
                      <app-cheapest-button
                        (hightLight)="
                          highlightCheapestTickets(['outbound-' + $event, 'inbound-' + $event])
                        "
                        (keydown)="resolveTabbingHighlight()"
                        [price]="[
                          data.cheapest.outboundCheapest.returnJourneyFares.price,
                          data.cheapest.cheapestClassTicketReturn.standardClassFare.price
                        ]"
                        [id]="'returns-cheapest-fares'"
                        i18n-message
                        message="Returns from: "
                      >
                      </app-cheapest-button>
                    </li>
                  }
                  @if (data.originalUserSearch.chosenSearchType === RailJourneyType.SingleJourney) {
                    <li>
                      <app-cheapest-button
                        (hightLight)="highlightCheapestTickets(['outbound-' + $event])"
                        (keydown)="resolveTabbingHighlight()"
                        [price]="[
                          data.cheapest.outboundCheapest.singleJourneyFares.price,
                          data.cheapest.cheapestClassTicket.standardClassFare.price,
                          data.cheapest.cheapestClassTicket.firstClassFare.price
                        ]"
                        i18n-message
                        [id]="'singles-cheapest-fare'"
                        message="Singles from: "
                      >
                      </app-cheapest-button>
                    </li>
                  }
                  @if (
                    data.cheapest.cheapestClassTicketDual &&
                    data.originalUserSearch.chosenSearchType === RailJourneyType.ReturnJourney
                  ) {
                    <li>
                      <app-cheapest-button
                        (hightLight)="
                          highlightCheapestTickets([
                            'outbound-' + getCheapestDualOutbound(data.cheapest),
                            'inbound-' + getCheapestDualInbound(data.cheapest)
                          ])
                        "
                        (keydown)="resolveTabbingHighlight()"
                        [price]="[
                          data.cheapest.outboundCheapest.dualSingleJourneyFares.price +
                            data.cheapest.inboundCheapest.dualSingleJourneyFares.price,
                          data.cheapest.cheapestClassTicketDual.standardClassFare.price +
                            data.cheapest.cheapestClassTicketDual.inboundStandardClassFare.price
                        ]"
                        i18n-message
                        [id]="'two-singles-cheapest-fares'"
                        message="Two singles from: "
                      >
                      </app-cheapest-button>
                    </li>
                  }
                  @if (
                    data.cheapest.outboundCheapest.splitFares.price > 0 &&
                    data.originalUserSearch.chosenSearchType === RailJourneyType.ReturnJourney
                  ) {
                    <li>
                      <app-cheapest-button
                        (hightLight)="
                          highlightCheapestTickets(['outbound-' + $event, 'inbound-' + $event])
                        "
                        (keydown)="resolveTabbingHighlight()"
                        [price]="[data.cheapest.outboundCheapest.splitFares.price]"
                        i18n-message
                        [id]="'split-cheapest-fares'"
                        message="Split fares from: "
                      >
                      </app-cheapest-button>
                    </li>
                  }
                  @if (
                    data.cheapest.cheapestTicketLowCo2Outbound &&
                    data.cheapest.cheapestTicketLowCo2Inbound &&
                    displayLowCo2Button
                  ) {
                    <li>
                      <app-cheapest-button
                        (hightLight)="highlightCO2Tickets(getCheapestCo2Ticket(data))"
                        (keydown)="resolveTabbingHighlight()"
                        [price]="[getCheapestCo2Ticket(data)?.totalPrice]"
                        i18n-message
                        [id]="'co2-cheapest-fares'"
                        message="Carbon efficient: "
                      >
                      </app-cheapest-button>
                    </li>
                  }
                  @if (data.results[0].return?.length) {
                    <li>
                      <button
                        (click)="openCheapestFareFinder()"
                        appButton="small"
                        class="small-button--margin"
                        id="cheapest-fare-finger"
                        i18n="@@cheapestFareFinder2"
                      >
                        Cheapest fare finder
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
          @if (
            !data.fullWidth && data.results[0]?.outbound.length && data.results[0]?.return.length
          ) {
            <div class="flex-row-container rail_results_hint" i18n="@@SelectIntrsuctions">
              Select one price option from the Outbound table and one option from the Return table.
            </div>
          }
          @if (data.results[0]?.outbound.length || data.results[0]?.return.length) {
            <div class="search_results_items">
              <app-rail-results-block
                [sourceId]="data.results[0].sourceId"
                class="rail_search_results_outbound"
                direction="outbound"
                [expandedTickets]="expandedTickets"
                [fareTypes]="makeFareNames | memoize: data.results[0].outbound"
                [from]="
                  data.originalUserSearch.travellingFrom
                    ? (data.originalUserSearch.travellingFrom.name | titlecase)
                    : (data.results[0].outbound[0].from | titlecase)
                "
                [to]="
                  data.originalUserSearch.travellingTo
                    ? (data.originalUserSearch.travellingTo.name | titlecase)
                    : (data.results[0].outbound[0].to | titlecase)
                "
                (earlier)="earlier($event, data, 'outbound')"
                (later)="
                  getNextResultsPage(
                    data.results[0].outbound[getFinalDisplayedResultIndex(data.results[0].outbound)]
                      .departDateTime,
                    RailSearchCriteria.Depart,
                    data.results[0].outbound[0],
                    data.results[0].outbound[
                      getFinalDisplayedResultIndex(data.results[0].outbound)
                    ],
                    EarlierOrLater.LATER
                  )
                "
                (prevDay)="getDifferentDayPage(EarlierOrLater.EARLIER, false)"
                (nextDay)="getDifferentDayPage(EarlierOrLater.LATER, false)"
                [date]="data.originalUserSearch.outBoundDateTime.format() | sabsDate: 1"
                [journeys]="data.results[0].outbound"
              ></app-rail-results-block>
              @if (!data.fullWidth) {
                <app-rail-results-block
                  [sourceId]="data.results[0].sourceId"
                  class="rail_search_results_return"
                  direction="inbound"
                  [expandedTickets]="expandedTickets"
                  [fareTypes]="makeFareNames | memoize: data.results[0].outbound"
                  [to]="
                    data.originalUserSearch.travellingFrom
                      ? (data.originalUserSearch.travellingFrom.name | titlecase)
                      : (data.results[0].return[0].to | titlecase)
                  "
                  [from]="
                    data.originalUserSearch.travellingTo
                      ? (data.originalUserSearch.travellingTo.name | titlecase)
                      : (data.results[0].return[0].from | titlecase)
                  "
                  (earlier)="earlier($event, data, 'return', true)"
                  (later)="
                    getNextResultsPage(
                      data.results[0].return[getFinalDisplayedResultIndex(data.results[0].return)]
                        .departDateTime,
                      RailSearchCriteria.Depart,
                      data.results[0].return[0],
                      data.results[0].return[getFinalDisplayedResultIndex(data.results[0].return)],
                      EarlierOrLater.LATER,
                      true
                    )
                  "
                  (prevDay)="getDifferentDayPage(EarlierOrLater.EARLIER, true)"
                  (nextDay)="getDifferentDayPage(EarlierOrLater.LATER, true)"
                  [date]="data.originalUserSearch.inBoundDateTime.format() | sabsDate: 1"
                  [journeys]="data.results[0].return"
                  [outboundJourneys]="data.results[0].outbound"
                ></app-rail-results-block>
              }
              @if (data.fullWidth && !searchParams.openReturn) {
                <div class="inbound_prompt">
                  <button appButton="large" (click)="openReturn()">
                    Click to add a return journey
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (
        data.results.length === 0 ||
        data.results[0]?.outbound.length === 0 ||
        (data.results[0]?.outbound.length === 0 && data.results[0]?.return.length === 0)
      ) {
        <app-no-results></app-no-results>
      }
    </div>
  }
}
